import { render, staticRenderFns } from "./BackgroundOverall.vue?vue&type=template&id=3cf79ad0&scoped=true"
import script from "./BackgroundOverall.vue?vue&type=script&lang=js"
export * from "./BackgroundOverall.vue?vue&type=script&lang=js"
import style0 from "./BackgroundOverall.vue?vue&type=style&index=0&id=3cf79ad0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf79ad0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cf79ad0')) {
      api.createRecord('3cf79ad0', component.options)
    } else {
      api.reload('3cf79ad0', component.options)
    }
    module.hot.accept("./BackgroundOverall.vue?vue&type=template&id=3cf79ad0&scoped=true", function () {
      api.rerender('3cf79ad0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/background/BackgroundOverall.vue"
export default component.exports